<template>
  <div style="display: flex; flex-direction: column; align-items: flex-end">
    <div class="d-flex">
      <management-button
        v-if="isTaskBlocked"
        class="map-button"
        type="execute"
        :label="$t('Show Message')"
        @buttonClick="showErrorMsg"
      />
      <management-button
        v-if="taskDecisionButtons || isTaskBlocked"
        class="map-button"
        type="execute"
        :label="$t('Submit')"
        @buttonClick="submit"
        :disabled=" taskDecisionButtons ? taskContents.length !== checklist.length : !(taskContents.length > 0)"
      />
    </div>
    <v-data-table
      :headers="headers"
      :items="checklist"
      :loading="loading"
      loading-text=""
      :no-data-text = "$t('AddToTable')"
      :items-per-page-text="rowsPerPageText"
      :items-per-page-items="allRows ? allRows : rowsPerPageItems"
      :header-props="{ sortIcon }"
      :footer-props="{ prevIcon, nextIcon }"
      class="elevation-2"
      :style="[
        taskDecisionButtons ? { 'margin-top': '10px' } : { 'margin-top': '0' }
      ]"
    >
      <template v-slot:item="props">
        <tr>
          <td>
            <v-checkbox
              :disabled="true"
              :ripple="false"
              color="#4fa2b7"
              v-model="props.item.value"
              disableFuzzyMatching
            />
          </td>
          <td class="text-xs-left">
            <v-icon v-if="props.item.blocked" color="error">
              priority_high
            </v-icon>
            {{ props.item.label }}
          </td>
          <td class="text-xs-left">{{ props.item.type }}</td>
          <td class="text-xs-left">{{ props.item.required ? 'True' : 'False'}}</td>
          <td class="text-xs-left">{{ Number(props.item.index) }}</td>
          <td class="text-xs-left">{{ props.item.value ? 'True' : 'False' }}</td>
          <td class="text-xs-left">
            <app-datatable-action-buttons
              v-if="!editionDisabled"
              :user-can-edit="true"
              @edit="$emit('editItem', props.item)"
              :user-can-delete="true"
              @delete="$emit('removeItem', props.item)"
            />
          </td>
          <td v-if="taskManagement">
            <task-decision-buttons
              v-if="taskDecisionButtons || isTaskBlocked"
              @approve="
                $emit('updateTaskContents', {
                  decision: 'approve',
                  uuid: props.item.uuid
                })
              "
              @reject="
                $emit('updateTaskContents', {
                  decision: 'reject',
                  uuid: props.item.uuid
                })
              "
              :isTaskBlocked="isTaskBlocked"
              :uuid="props.item.uuid"
              :taskContents="taskContents"
            />
          </td>
        </tr>
      </template>
      <template v-slot:pageText="props">
        {{ props.pageStart }} - {{ props.pageStop }} {{ $t("tables.Of") }}
        {{ props.itemsLength }}
      </template>

      <template v-slot:no-data>
        <div v-if="loading" />
      </template>
    </v-data-table>
    <text-message :textDialog="textDialog" :text="textMsg" @closeTextDialog="closeTextDialog"/>
    <app-dialog-box
      :open="rejectDialog"
      :title="$t('RejectTask')"
      :content="$t('RejectionMessage') + '*'"
      :main-action-label="$t('Cancel')"
      @mainAction="cancelRejection"
      :secondary-action-label="$t('Reject')"
      :secondary-action-disable="rejectionMessage.trim().length !== 0"
      @secondaryAction="rejectTask"
      :loading="loadingDelete"
    >
      <div slot="dialog-textbox" class="rejection-message-textarea">
        <textarea
          v-model="rejectionMessage"
          class="input-field"
          maxlength="1024"
        />
        <label>{{ $t("RejectionNote") }}</label>
      </div>
    </app-dialog-box>
  </div>
</template>

<script>
import { activitiesTasksDataMixin } from "@/mixins/field/activitiesTasksDataMixin";
import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
import AppDatatableActionButtons from "@/components/_Molecules/AppDatatableActionButtons";
import TaskDecisionButtons from "@/components/FieldManagement/FieldWork/Data/TaskDecisionButtons";
import AppDialogBox from "@/components/_Molecules/AppDialogBox";
import ManagementButton from "@/components/Management/ManagementButton";
import TextMessage from '../../../../../../FieldManagement/FieldWork/Data/TaskType/TextMessage.vue';
export default {
  name: "TaskChecklistTable",

  mixins: [activitiesTasksDataMixin, managementDatatableMixin],

  components: {
    AppDatatableActionButtons,
    TaskDecisionButtons,
    AppDialogBox,
    ManagementButton,
    TextMessage
  },

  data() {
    return {
      rejectDialog: false,
      loadingDelete: false,
      rejectionMessage: "",
      textDialog: false,
      textMsg: ""
    };
  },

  props: {
    checklist: {
      type: Array,
      required: true
    },

    editionDisabled: {
      type: Boolean,
      default: true
    },

    allRows: {
      type: Array
    },

    taskDecisionButtons: {
      type: Boolean,
      default: false
    },

    taskContents: {
      type: Array
    },
    taskManagement: {
      type: Boolean,
      default: false
    },
    isTaskBlocked:{
      type: Boolean,
      default: false
    },
    blockMessage:{
      type: String,
    }
  },

  computed: {
    headers() {
      let headers;
      if (this.taskManagement) {
        headers = [
          {
            text: `${this.$i18n.tc("State")}`,
            value: "state",
            width: "18.5%"
          },
          {
            text: `${this.$i18n.tc("Label")}`,
            value: "label",
            width: "11.5%"
          },
          {
            text: `${this.$i18n.tc("Type")}`,
            value: "type",
            width: "11.5%"
          },
          {
            text: `${this.$i18n.tc("Required")}`,
            value: "required",
            width: "11.5%"
          },
          {
            text: `${this.$i18n.tc("Index")}`,
            value: "index",
            width: "11.5%"
          },
          {
            text: `${this.$i18n.tc("Value")}`,
            value: "value",
            width: "11.5%"
          },
          {
            text: "",
            value: "action",
            sortable: false,
            width: "11.5%"
          },
          {
            text: "",
            value: "decision",
            sortable: false,
            width: "11.5%"
          }
        ];
      }else{
        headers = [
          {
            text: `${this.$i18n.tc("State")}`,
            value: "state",
            width: "10%"
          },
          {
            text: `${this.$i18n.tc("Label")}`,
            value: "label",
            width: "26%"
          },
          {
            text: `${this.$i18n.tc("Type")}`,
            value: "type",
            width: "13%"
          },
          {
            text: `${this.$i18n.tc("Required")}`,
            value: "required",
            width: "13%"
          },
          {
            text: `${this.$i18n.tc("Index")}`,
            value: "index",
            width: "12%"
          },
          {
            text: `${this.$i18n.tc("Value")}`,
            value: "value",
            width: "13%"
          },
          {
            text: "",
            value: "action",
            sortable: false,
            width: "13%"
          }
        ];
      }
      return headers;
    }
  },

  methods: {
    cancelRejection() {
      this.rejectDialog = false;
      this.rejectionMessage = "";
    },

    rejectTask() {
      this.$emit("rejectTask", this.rejectionMessage);
      this.cancelRejection();
    },

    submit() {
      if (
        this.taskContents.filter(item => item.decision === "reject").length > 0
      ) {
        this.rejectDialog = true;
      } else {
        this.$emit("approveTask");
      }
    },
    showErrorMsg(){
      this.textDialog = true;
      this.textMsg = this.blockMessage;
    },
    closeTextDialog(){
      this.textDialog = false;
      this.textMsg = "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Activities/TaskTypes/Checklists/ChecklistTable.vue